import { useNavigate, useSearchParams } from "react-router-dom";
import { PublicGuard } from "@/components/auth-guard";
import { AuthShell } from "@/components/auth-shell";
import SignInForm from "@/components/sign-in-form";
import { WORKER_WEB_BLOCKED_QUERY_PARAM } from "@/components/worker-web-access-gate";

export default function SignIn() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redirectParam = searchParams.get("redirect");
  const redirectPath = redirectParam?.startsWith("/") ? redirectParam : null;
  const showWorkerWebBlockedMessage =
    searchParams.get(WORKER_WEB_BLOCKED_QUERY_PARAM) === "1";

  const handleSwitchToSignUp = () => {
    const nextSearch = redirectPath
      ? `?redirect=${encodeURIComponent(redirectPath)}`
      : "";
    navigate(`/sign-up${nextSearch}`);
  };

  return (
    <PublicGuard>
      <AuthShell title="Welcome back" description="Next level site management">
        <SignInForm
          onSwitchToSignUp={handleSwitchToSignUp}
          showWorkerWebBlockedMessage={showWorkerWebBlockedMessage}
        />
      </AuthShell>
    </PublicGuard>
  );
}
